import { Application } from '@hotwired/stimulus'

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
;(window as any).Stimulus = application //A semicolon is necessary here to prevent a compilation error

export { application }
